export default function Overvejelser() {
  return (
    <div className="container mt-20 mx-auto">
      <div>
        <h4 className="text-dxl md:text-d2xl font-bold text-doctio-green">
          Overvejelser, medier & dokumenter
        </h4>

        <p>
          I fanen "Overvejelser" har man mulighed for at skrive vigtig klinisk
          information, personlige noter og indsætte links til ressourcer som
          lægehåndbøger eller nationale, regionale og lokale instrukser. Dette
          ligner funktionaliteten af "Noter"-klikelementet, der er blevet
          gennemgået i en tidligere video.
        </p>

        <p>
          I fanen "Medier" kan man indsætte videoer fra platforme som YouTube
          eller billeder, man selv uploader. For at tilføje en video skal man
          klikke på "Tilføj video" og indsætte linket til videoen fra YouTube.
          Derudover kan man tilføje en overskrift og eventuelle noter i det
          tilhørende felt. Når det kommer til at uploade billeder, følger
          processen en lignende tilgang, hvor man skal vælge en fil fra sin
          computer ved at klikke på "Vælg fil". Man får også mulighed for at
          tilføje en overskrift og noter. Billeder kan være nyttige til
          genkendelse af hudsygdomme, behandlingsflowcharts eller som
          forklarende billeder til læger eller patienter. Videoer kan bruges til
          hurtigt at genopfriske kliniske undersøgelser eller procedurer.
        </p>

        <p>
          Endelig er der fanen "Dokumenter", hvor man kan uploade dokumenter som
          Word-dokumenter eller PDF'er. Disse dokumenter kan omfatte skemaer,
          som patienter skal udfylde, f.eks. MDS-skema til depression, eller
          patientinformationsfoldere om graviditet, nykonstaterede kroniske
          sygdomme, behandlingsoplysninger, medicin osv.
        </p>
      </div>

      <div className="mt-10">
        <iframe
          width="560"
          height="315"
          className="h-[200px] md:h-[600px]"
          style={{ width: "100%", borderRadius: "10px" }}
          src="https://www.youtube.com/embed/zz743Ci5iKA?si=qyZZ99G0ceH4c6Tj"
          title="YouTube video player"
          frameBorder={0}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen={true}
        ></iframe>
      </div>
    </div>
  );
}
